<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <div class="va-card">
        <div class="va-card__header-inner">
          <div class="va-card__header-title" style="color: rgb(44, 130, 224);">  {{ $t('profile.editCompany') }}</div>
        </div>
        <div class="va-card__body">
          <form @submit.prevent="onsubmit()">
            <div class="row">
              <va-input
                v-model="name"
                type="text"
                :label="$t('profile.inputName')"
                :error="!!nameErrors.length"
                :error-messages="nameErrors"
                class="flex xs12 sm6 md6 lg6 xl6"
              />

              <div class="flex xs12 sm6 md6 lg6 xl6">
                <va-select
                  :label="$t('profile.selectCountry')"
                  v-model="country"
                  textBy="name"
                  keyBy="countryId"
                  searchable
                  :options="countries"
                  :error="!!countryErrors.length"
                  :error-messages="countryErrors"
                />
              </div>

              <va-input
                v-model="description"
                type="text-area"
                :label="$t('profile.inputDescription')"
                class="flex xs12"
              />

              <va-input
                v-model="email"
                type="email"
                :label="$t('profile.inputEmail')"
                class="flex xs12 sm6 md6 lg6 xl6"
              />

              <va-input
                v-model="telephone"
                type="text"
                :label="$t('profile.inputTelephone')"
                class="flex xs12 sm6 md6 lg6 xl6"
              />

              <va-input
                v-model="address"
                type="text"
                :label="$t('profile.inputAddress')"
                class="flex xs12"
              />

              <va-input
                v-model="vat"
                type="text"
                :label="$t('profile.inputVat')"
                class="flex xs12"
                :error="!!vatErrors.length"
                :error-messages="vatErrors"
              />
            </div>
            <div class="d-flex justify--center mt-3">
              <va-button type="submit" class="my-0">{{ $t('profile.btnUpdateCompany') }}</va-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
// const validate = require('validate-vat')
export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'Company',
  data () {
    return {
      email: '',
      name: '',
      description: '',
      telephone: '',
      country: {},
      vat: '',
      address: '',
      countries: [],
      nameErrors: [],
      countryErrors: [],
      vatErrors: [],
    }
  },
  methods: {
    onsubmit () {
      this.countryErrors = this.country ? [] : [this.$t('profile.requiredCountry')]
      this.nameErrors = this.name ? [] : [this.$t('profile.requiredName')]
      // if (this.vat) {
      //   const euVatedCountries = ['SE', 'ES', 'SI', 'SK', 'RO', 'PT', 'PL', 'NO', 'NL', 'MT', 'LU', 'LT', 'LV', 'IT', 'IE', 'HU', 'DE', 'FR', 'FI', 'DK', 'CZ', 'CY', 'BG', 'BE', 'AT']
      //   if (euVatedCountries.includes(this.country.code)) {
      //     // eslint-disable-next-line handle-callback-err
      //     validate(this.country.code, this.vat, (err, validationInfo) => {
      //     })
      //   }
      // }
      if (!this.formCompanyReady) {
        return
      }
      this.$store.commit('setLoading', true)
      this.$store.dispatch('companyUpdate', {
        email: this.email,
        name: this.name,
        description: this.description,
        telephone: this.telephone,
        vat: this.vat,
        countryId: this.country.countryId,
        address: this.address,
      }).then(() => this.$store.commit('setLoading', false)).catch(err => this.errorHandler(err.response))
    },
    async initCompany () {
      this.countries.splice(0, this.countries.length, ...this.$store.getters.countries)
      const company = this.$store.getters.company
      const companyCountry = this.countries.filter(function (item) {
        return item.countryId === company.countryId
      })
      this.name = company.name
      this.description = company.description
      this.email = company.email
      this.telephone = company.telephone
      this.vat = company.vat
      this.address = company.address
      this.country = companyCountry[0]
      this.$store.commit('setLoading', false)
    },
  },
  computed: {
    formCompanyReady () {
      return !(this.nameErrors.length || this.countryErrors.length)
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('companyRequest')
      .then(() => this.$store.dispatch('countries'))
      .then(() => this.initCompany())
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style scoped>

</style>
